// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"e63f7405","164":"4d428d5b","254":"a8fcd780","301":"110a0c32","444":"dba7c510","453":"f2173dbc","721":"7ff19fd8"}[chunkId] + ".chunk.js";
};